const services = [
    {
      name: "Petrol Pumps",
      icon: "https://example.com/icons/petrol-pump.svg" 
    },
    {
      name: "Parking",
      icon: "https://example.com/icons/parking.svg" 
    },
    {
      name: "Restaurants",
      icon: "https://example.com/icons/restaurant.svg" 
    },
    {
      name: "Toilets",
      icon: "https://example.com/icons/toilets.svg"
    },
    {
      name: "Shopping Centers",
      icon: "https://example.com/icons/shopping-center.svg" 
    },
    {
      name: "Hotels",
      icon: "https://example.com/icons/hotel.svg" 
    },
    {
      name: "Cafes",
      icon: "https://example.com/icons/cafe.svg" 
    },
    {
      name: "ATM",
      icon: "https://example.com/icons/atm.svg" 
    },
    {
      name: "Pharmacies",
      icon: "https://example.com/icons/pharmacy.svg" 
    },
    {
      name: "Rest Areas",
      icon: "https://example.com/icons/rest-area.svg" 
    },
    {
      name: "Wi-Fi Zones",
      icon: "https://example.com/icons/wifi.svg" 
    },
    {
      name: "Grocery Stores",
      icon: "https://example.com/icons/grocery-store.svg" 
    },
    {
      name: "EV Maintenance Services",
      icon: "https://example.com/icons/ev-maintenance.svg" 
    },
    {
      name: "Car Wash",
      icon: "https://example.com/icons/car-wash.svg" 
    },
    {
      name: "Recreational Areas",
      icon: "https://example.com/icons/recreational-area.svg" 
    },
    {
      name: "Fitness Centers",
      icon: "https://example.com/icons/fitness-center.svg" 
    },
    {
      name: "Cultural Sites",
      icon: "https://example.com/icons/cultural-site.svg" 
    },
    {
      name: "Public Transportation Hubs",
      icon: "https://example.com/icons/transportation-hub.svg" 
    }
  ];
  
  export default services;
  